export default "__VITE_ASSET__EOn9Ikxh__"